import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { RouteProvider } from './routes/RouteProvider';
import { ProgressContainer } from './store/progress/ProgressContainer';
import { SidebarVisibilityProvider } from './context/SidebarVisibilityContext';
import { HelmetProvider } from './components/Helmet';

export const App = () => {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <ProgressContainer>
        <SidebarVisibilityProvider>
          <HelmetProvider>
            <RouteProvider />
          </HelmetProvider>
        </SidebarVisibilityProvider>
      </ProgressContainer>
    </QueryClientProvider>
  );
};
